<template>
  <Box>
    <h2 class="text-t5 mb-3">Vad är underhåll?</h2>
    <p>
      Vi utför underhåll av din bostad enligt en tidsplan med olika tidsintervall. Exempel
      på underhåll är ommålning och tapetsering eller byte av kyl- och frys.
    </p>
    <Button variant="tertiary" size="large" class="mt-auto self-end" href="https://www.gavlegardarna.se/din-bostad/vart-underhall-av-din-bostad/">
      Läs mer om underhåll
      <template #icon-after>
        <IconArrowRight />
      </template>
    </Button>
  </Box>
</template>

<script>
import Box from '@/components/ui/box'
import Button from '@/components/ui/button'
import IconArrowRight from '@/components/icons/IconArrowRight'

export default {
  name: 'WhatIsMaintenance',
  components: {
    Box,
    Button,
    IconArrowRight
  }
}
</script>
